import { Link } from "react-router-dom";
import { LegalLayout } from "@/pages/legal/LegalLayout";

export default function Terms() {
  return (
    <LegalLayout
      eyebrow="Legal"
      title="Terms & Conditions"
      path="/terms-and-conditions"
      lastUpdated="September 1, 2026"
      seoTitle="Terms & Conditions | Legacy Spa"
      seoDescription="Legacy Spa Terms & Conditions, including SMS/text messaging terms, booking, payments, and governing law."
      intro="The terms that govern your use of the Legacy Spa website and services."
      sections={[
        {
          heading: "Acceptance of Terms",
          body: [
            "By accessing or using thelegacyspa.com or any Legacy Spa services, you agree to be bound by these Terms & Conditions and our Privacy Policy. If you do not agree, please do not use the website or services.",
          ],
        },
        {
          heading: "Website Use",
          body: [
            "You agree to use this website for lawful purposes only and not to interfere with its operation, security, or other users\u2019 use of the site. Content is provided for general informational purposes and may change without notice.",
          ],
        },
        {
          heading: "Booking & Appointments",
          body: [
            "Appointments are booked through Vagaro. Availability, service details, and scheduling are confirmed through the booking system. You are responsible for providing accurate information when booking.",
          ],
        },
        {
          heading: "Pricing & Promotions",
          body: [
            "Prices and promotions are subject to change and are confirmed at the time of booking. Promotional offers may have additional terms, eligibility requirements, or expiration dates.",
          ],
        },
        {
          heading: "Payments",
          body: [
            "Payments are processed through Vagaro and applicable third-party payment processors under their own terms. Legacy Spa does not store full payment card information on this website.",
          ],
        },
        {
          heading: "Cancellations & Rescheduling",
          body: [
            "If you need to cancel or reschedule, please do so as early as possible through the booking system or by contacting Legacy Spa. Specific cancellation and rescheduling details are provided at the time of booking.",
          ],
        },
        {
          heading: "Professional Conduct",
          body: [
            "Legacy Spa provides professional, therapeutic massage and wellness services. Any inappropriate, disrespectful, or unlawful conduct will result in immediate termination of the session and may be refused service. Legacy Spa reserves the right to decline or discontinue service at its discretion.",
          ],
        },
        {
          heading: "Health & Safety",
          body: [
            "Please inform your therapist of any relevant health conditions, injuries, allergies, or concerns before your session so services can be provided safely. Massage and wellness services are not a substitute for medical care, diagnosis, or treatment. Consult a qualified healthcare provider for medical concerns.",
          ],
        },
        {
          heading: "Intellectual Property",
          body: [
            "The Legacy Spa name, wordmark, logo, content, and brand elements are the property of Legacy Spa and may not be used without prior written permission.",
          ],
        },
        {
          heading: "Third-Party Services",
          body: [
            "Our website and services rely on third-party providers (such as Vagaro, communications/SMS platforms, and analytics). Legacy Spa is not responsible for the content, policies, or practices of third-party services.",
          ],
        },
        {
          heading: "SMS Messaging Terms",
          body: [
            "By affirmatively opting in to receive SMS communications from Legacy Spa, users agree to receive the categories of text messages described at the point of consent. Depending on your specific opt-in, potential messages may include:",
          ],
          list: [
            "Appointment confirmations",
            "Appointment reminders",
            "Scheduling communications",
            "Customer service communications",
            "Service updates",
            "Promotional or marketing messages when separately authorized",
          ],
        },
        {
          heading: "SMS Messaging — Rates, Opt-Out & Privacy",
          body: [
            "Message frequency may vary. Message and data rates may apply. Consent to receive marketing text messages is not a condition of purchase.",
            "Reply STOP to unsubscribe from applicable SMS messages. Reply HELP for assistance. You may also contact Legacy Spa at (832) 243-8853 or info@thelegacyspa.com.",
            "Carriers are not responsible for delayed or undelivered messages.",
            <span key="sms-pp">
              For details on how we handle your mobile information and consent data, see our{" "}
              <Link
                to="/privacy-policy"
                className="text-legacy-mint underline underline-offset-2 hover:text-white"
                data-testid="terms-sms-privacy-link"
              >
                Privacy Policy
              </Link>
              .
            </span>,
          ],
        },
        {
          heading: "Disclaimers",
          body: [
            "The website and services are provided \u201cas is\u201d and \u201cas available\u201d without warranties of any kind, whether express or implied, to the fullest extent permitted by law.",
          ],
        },
        {
          heading: "Limitation of Liability",
          body: [
            "To the fullest extent permitted by law, Legacy Spa shall not be liable for any indirect, incidental, special, consequential, or punitive damages arising from your use of the website or services.",
          ],
        },
        {
          heading: "Governing Law",
          body: [
            "These Terms & Conditions are governed by and construed in accordance with the laws of the State of Texas, without regard to its conflict-of-law principles.",
          ],
        },
        {
          heading: "Changes to These Terms",
          body: [
            "Legacy Spa may update these Terms & Conditions from time to time. The \u201cLast Updated\u201d date above reflects the most recent revision. Continued use of the website or services after changes take effect constitutes acceptance of the updated terms.",
          ],
        },
        {
          heading: "Contact Information",
          body: [
            "Legacy Spa \u2014 Houston, Texas. Email: info@thelegacyspa.com \u00b7 Phone: (832) 243-8853 \u00b7 Website: thelegacyspa.com.",
          ],
        },
      ]}
    />
  );
}
